import { render, staticRenderFns } from "./StatusMessageDoughnutChart.vue?vue&type=template&id=518bd720&scoped=true&"
import script from "./StatusMessageDoughnutChart.vue?vue&type=script&lang=js&"
export * from "./StatusMessageDoughnutChart.vue?vue&type=script&lang=js&"
import style0 from "./StatusMessageDoughnutChart.vue?vue&type=style&index=0&id=518bd720&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518bd720",
  null
  
)

export default component.exports